import React, { FunctionComponent } from "react";
import { StepWrapper, Title, Paragraph } from "../styles/diversity-form-styles";

const ThankYou: FunctionComponent<unknown> = () => (
  <StepWrapper data-test-id="thank-you-step" thankYou>
    <Title data-test-id="title">Thank you</Title>
    <Paragraph data-test-id="paragraph" first>
      Thank you so much for trusting us with who you are. Just to remind you,
      all your data is anonymised and in no way traceable to your application.
    </Paragraph>
    <Paragraph data-test-id="paragraph" last>
      The data is collected with the sole purpose of monitoring On the Beach’s
      hiring process and ensuring that recruitment agencies and On the Beach
      embodies their values of diversity and inclusion.
    </Paragraph>
  </StepWrapper>
);

export default ThankYou;
